:host {
  display: block;
}

.menu-card-price {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  margin-top: 4px;
}

.menu-card-price--multi-line {
  display: block;
}

.menu-card-price__text {
  color: #333333;
  font-weight: bold;
}

.menu-card-price__tooltip {
  width: 18px;
  height: 18px;
}

:host(:not([dir="rtl"])) .menu-card-price__tooltip {
  margin-left: 4px;
}

:host([dir="rtl"]) .menu-card-price__tooltip {
  margin-right: 4px;
}

.menu-card-price__label {
  font-size: 12px;
  line-height: 16px;
}